export const CHATBOT_PARAMS_SYNC = 'chatbot-params-sync';

export type ChatbotParamsSyncDetail = {
  theme?: 'dark' | 'light';
  locale?: string;
};

export interface ChatbotEnv {
  baseUrl: string;
  navUrl: string;
  getToken: () => string | null | undefined;
  /** Help Center base URL，由各 app 从其 localized/config/site 注入 */
  helpCenterUrl: string;
  /** Chatbot WebSocket 基础域名（环境前缀由 baseUrl 自动派生），由各 app 注入 */
  wsBaseDomain: string;
  /** Chatbot SDK CDN fallback origin，当 navUrl 解析失败时使用，由各 app 注入 */
  cdnFallback: string;
  geetestCaptchaId?: string;
}

export interface ChatbotInitConfig {
  lang: string;
  theme: 'dark' | 'light';
  pageType: 'trade' | 'default';
  token: string;
  uid?: string;
  geetestCaptchaId: string;
  apiBaseUrl: string;
  wsBaseUrl: string;
  helpCenterBaseUrl: string;
  cfIpCountry: string;
}

export interface ChatbotGrayGateProps {
  theme: 'dark' | 'light';
  env: ChatbotEnv;
  /** 韩国站不接入 Chatbot，传 true 时本组件不做任何注入。 */
  isKrSite?: boolean;
  pageType?: 'trade' | 'default';
}
